import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'
import VueAxios from 'vue-axios'
import './index.css'
import VueSocialSharing from 'vue-social-sharing'

Vue.use(VueSocialSharing,{
  networks: {
    fakeblock: 'https://fakeblock.com/share?url=@url&title=@title'
  }
});

Vue.config.productionTip = false

const init = () => {
new Vue({
  router,
  axios,
  VueAxios,
  render: h => h(App),
  data: function(){
    return{
      cordova: Vue.cordova
    }
  }
}).$mount('#app')
}



// Wait for the deviceready event to start the render
document.addEventListener("deviceready", () => {
  // eslint-disable-next-line
  console.log("Ready, Render the App");
  console.log(navigator.camera);
  init();
});

// If we are not in Cordova, manually trigger the deviceready event
const isCordovaApp = (typeof window.cordova !== "undefined");
if (!isCordovaApp){
  document.dispatchEvent(new CustomEvent("deviceready", {}));
}

